module.exports = __webpack_public_path__ + "static/infra-banner-c997c20eef7d25e1f2002813ad82aaea.jpg";